import { useDocumentTitle } from "@/i18n";
import { ResetPasswordPageView } from "./_components";

export default function ResetPasswordPage() {
  useDocumentTitle("resetPassword.page");
  return <ResetPasswordPageView />;
}
